// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"327b1ed7","450":"aff2703d","529":"04a2a135","884":"bd07bfad"}[chunkId] + ".chunk.js";
};